import { getAllRoutes } from '../helpers/routes'
import { Route } from 'react-router-dom'

const getRoutesBasedOnToken = ({ token, group, navigate }) => {

    if (token) {
        
        const { role: { routes }} = token || { }

        const filter = routes.filter((item) => item.group === group)

        const listRoutes = filter.map(( { page } ) => {
            const routeFound = getAllRoutes({ navigate }).find((route) => route.page === page)
            return routeFound ? routeFound.component : <Route />
        })

        return listRoutes
    }

    return []

}

export {
    getRoutesBasedOnToken
} 